import moment from 'moment';

angular.module('backOffice').filter(
    'formatDateTimeDisplay',
    () =>
        function (input) {
            return moment(input).format('MM-DD-YYYY h:mm A');
        }
);
